import React, { Component } from "react";
import "./styles/Vchart.css";
import moment from "moment";
import { Tooltip } from "reactstrap";
import { Right } from "react-bootstrap/lib/Media";
class Vchart extends Component {
  constructor(props) {
    super(props);
    this.state = { tooltipOpen: false, TooltipID: 9999 };
  }
  toggle = (index) => {
    if (this.state.tooltipOpen) {
      index = 99999;
    }
    this.setState({ tooltipOpen: !this.state.tooltipOpen, TooltipID: index });
  };

  calculator(min, max, item) {
    const dis = max - min;
    const reducedItem = item - min;
    var result = Math.round((reducedItem * 100) / dis);
    result = result > 100 ? 100 : result;
    return result;
  }
  ycalc(val, max) {
    let per = (100 * val) / max;
    if (per < 0) {
      per = 0;
    }
    return per;
  }
  minmax(arr) {
    // min & max
    if (arr.length > 0) {
      let element = [];
      for (let index = 0; index < arr.length; index++) {
        element.push(parseInt(arr[index].y));
      }
      // if (arr.length == 1) {
      //   element = [
      //     Math.round(arr[0].y * (1 + 0.5)),
      //     Math.round(arr[0].y / (1 + 0.5)),
      //   ];
      // }
      let snumber = Math.min(...element).toFixed(0);
      if (snumber > 0) {
        snumber = 0;
      } else if (snumber < 0) {
        snumber = parseInt(snumber);
      }
      let lnumber = Math.max(...element).toFixed(0);
      lnumber = Math.round(parseInt(lnumber) * (1 + 0.3));
      // labels
      let items = 5,
        increments = (lnumber - snumber) / items;
      increments = Math.round(increments);
      if (increments < 1) {
        increments = 1;
      }
      let result = [...Array(items + 1)].map(
        (x, y) => +Math.round(snumber + increments * y)
      );
      lnumber = result[result.length - 1];
      let minmax = [];
      if (
        (snumber == 0 && lnumber == 1) ||
        (snumber > 0 && lnumber < 1) ||
        (snumber == 0 && lnumber == 0)
      ) {
        minmax = [0, 1.25, [0, 0.25, 0.5, 0.75, 1, 1.25]];
      } else {
        minmax = [snumber, lnumber, result];
      }

      return minmax;
    } else {
      return false;
    }
  }

  poinMaker(items, bottom, left, secondDataItem, index) {
    const classitem = secondDataItem ? "pointItem second" : "pointItem";
    return (
      <div
        className={classitem}
        // id={"TooltipParent" + index}
        id={secondDataItem ? "TooltipParent" + index : ""}
        style={{
          left: left,
          bottom: bottom,
        }}
      >
        {items && (
          // <ul>
          //   {items.map((item) => {
          //     return (
          //       <li data-toggle="tooltip" data-placement="auto">
          //         {item.fullname}
          //       </li>
          //     );
          //   })}
          // </ul>
          <Tooltip
            delay={15}
            placement="auto"
            isOpen={
              this.state.TooltipID == index ? this.state.tooltipOpen : false
            }
            target={"TooltipParent" + index}
            toggle={() => this.toggle(index)}
            style={{
              border: "1px solid #333",
              backgroundColor: "#222",
              textAlign: "left",
              fontSize: "0.6rem",
              color: "#999",
            }}
          >
            <ul>
              {items.map((item) => {
                return <li>{item.fullname}</li>;
              })}
            </ul>
          </Tooltip>
        )}
        {/* <label /> */}
      </div>
    );
  }
  xLabelMaker(val, end) {
    val = moment(val).endOf("day");
    let dateOut = "";
    if (end === "1W" || end === "2W" || end === "1M") {
      dateOut = val.format("MMM DD");
    } else {
      dateOut = val.format("MMM YYYY");
    }

    return dateOut;
  }
  render() {
    const { data, xLabels, yLabels, yRightLabels, secondData, OptionForm } =
      this.props;
    let yRightLabelsN = this.minmax(secondData);
    let yLabelsN = this.minmax(data);
    var bottom = 0;
    var bots = 0;
    var botss = 0;
    var left = 0;
    const RightBorder = yRightLabels ? "rightBorderOn" : "";
    return (
      <div
        className="chartContainer"
        style={{
          opacity: data.length == 0 && secondData.length == 0 ? 0 : 1,
        }}
      >
        <div className={`chartArea ${RightBorder}`}>
          <div className="xLabelsRowStyle">
            {xLabels.data &&
              xLabels.data.map((item) => {
                return (
                  <label
                    className="xLabelsStyle"
                    style={{
                      left: `${this.calculator(
                        xLabels.min.unix(),
                        xLabels.max.unix(),
                        item.unix()
                      )}%`,
                    }}
                  >
                    {this.xLabelMaker(item, OptionForm.end)}
                  </label>
                );
              })}
          </div>
          {xLabels.data &&
            xLabels.data.map((item) => {
              return (
                <div
                  className="xLineStyle"
                  style={{
                    left: `${this.calculator(
                      xLabels.min.unix(),
                      xLabels.max.unix(),
                      item.unix()
                    )}%`,
                  }}
                />
              );
            })}

          <div className="yLabelsRowStyle" style={{ textAlign: "right" }}>
            {yLabelsN[2] &&
              yLabelsN[2].map((item) => {
                let bottoml = [0, 20, 40, 60, 80, 100];
                let i = bots++;
                return (
                  <label
                    className="yLabelsStyleLeft"
                    style={{
                      bottom: `${bottoml[i]}%`,
                      textAlign: "right",
                    }}
                  >
                    {item}
                  </label>
                );
              })}
          </div>
          {yRightLabelsN && (
            <div className="yRightLabelsRowStyle">
              {yRightLabelsN[2] &&
                yRightLabelsN[2].map((item) => {
                  let bottomr = [0, 20, 40, 60, 80, 100];
                  let ib = botss++;
                  return (
                    <label
                      className="yLabelsStyleRight"
                      style={{
                        // bottom: `${this.calculator(
                        //   yLabels.min,
                        //   yLabels.max,
                        //   item
                        // )}%`
                        bottom: `${bottomr[ib]}%`,
                      }}
                    >
                      {item}
                    </label>
                  );
                })}
            </div>
          )}
          {yLabels.data &&
            yLabels.data.map((item) => {
              return (
                <div
                  className="yLineStyle"
                  style={{
                    bottom: `${this.calculator(
                      yLabels.min,
                      yLabels.max,
                      item
                    )}%`,
                  }}
                />
              );
            })}

          {data &&
            data.map((item, index) => {
              const bottom =
                // this.ycalc(Math.round(item.y), yLabelsN[1]).toString() + "%";
                this.ycalc(item.y, yLabelsN[1]).toString() + "%";
              const left =
                this.calculator(
                  xLabels.min.unix(),
                  xLabels.max.unix(),
                  item.x.unix()
                ).toString() + "%";
              return this.poinMaker(item.items, bottom, left, false, index);
            })}
          {secondData &&
            secondData.map((item, index) => {
              //alert(yLabelsN);
              const bottom =
                this.ycalc(item.y, yRightLabelsN[1]).toString() +
                //this.ycalc(item.y, yRightLabelsN[1]).toString() +
                "%";
              const left =
                this.calculator(
                  xLabels.min.unix(),
                  xLabels.max.unix(),
                  item.x.unix()
                ).toString() + "%";
              return this.poinMaker(item.items, bottom, left, true, index);
            })}
        </div>
      </div>
    );
  }
}

export default Vchart;



// WEBPACK FOOTER //
// ./src/components/Vchart.js